import Axios from "axios";

export class ProveedorPnService {

    getLista(params) {
        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/proveedor-pn/lista?${queryParams}`).then(res => res.data);
    }

    newProveedor(data) {
        return Axios.post(`${process.env.REACT_APP_URL_BACK}/ficha/trust/proveedor-pn/nuevo`, data).then(res => res.data);
    }

    editarProveedor(data) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/ficha/trust/proveedor-pn/editar`, data).then(res => res.data);
    }

    eliminarProveedor(id) {
        return Axios.delete(`${process.env.REACT_APP_URL_BACK}/ficha/trust/proveedor-pn/eliminar/${id}`).then(res => res.data);
    }

    consultarProveedor(id, opciones = {}) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/proveedor-pn/consulta/${id}`, { params: opciones }).then(res => res.data);
    }

    descargar(id, opciones = {}) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/proveedor-pn/reporte/${id}`, {
            params: opciones,
            headers: { 'Content-Type': 'application/json', 'Pragma': 'no-cache' }, responseType: 'blob'
        }).then(async res => res.data);
    }
}
